import Swiper, { FreeMode, Navigation, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

function initializeSliderBrands(containerThumbsId, containerContentId) {
    const containerThumbs = $(containerThumbsId);

    const swiperBrandsThumbs = new Swiper(containerThumbsId, {
        modules: [Navigation, FreeMode],

        slidesPerView: 5,
        spaceBetween: 22,
        allowTouchMove: false,
        loop: true,

        navigation: {
            prevEl: '.slider-brands .btn-prev',
            nextEl: '.slider-brands .btn-next',
        },

        breakpoints: {
            0: {
                slidesPerView: 'auto',              
                allowTouchMove: true
            },
            //sm
            640: {
                slidesPerView: 3,
                allowTouchMove: false,

            },
            //lg
            1024: {
                slidesPerView: 4,
                allowTouchMove: false,

            },
            //xl
            1280: {
                slidesPerView: 5,
                allowTouchMove: false,

            },
        },     
        
    });

    const swiperBrandsContent = new Swiper(containerContentId, {
        modules: [EffectFade],

        slidesPerView: 1,
        spaceBetween: 30,
        allowTouchMove: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },        
    });

    swiperBrandsThumbs.on('slideChangeTransitionEnd', ()=> {
        const name = $('.slider-brands-thumbs .swiper-slide-active').attr('data-name');
        const index = $('.slider-brands-content [data-name="' + name +'"]').attr('data-swiper-slide-index');
        $('.slider-brands-thumbs .swiper-slide').removeClass('active');
        $('.slider-brands-thumbs [data-name="' + name +'"]').addClass('active');
        swiperBrandsContent.slideTo(index)
    });

    $('.slider-brands-thumbs .swiper-slide').on('click', (e)=> {
        const name = $(e.target.closest('.swiper-slide')).attr('data-name');
        const index = $('.slider-brands-content [data-name="' + name +'"]').attr('data-swiper-slide-index');
        swiperBrandsContent.slideTo(index);
        $('.slider-brands-thumbs .swiper-slide').removeClass('active');
        $(e.target.closest('.swiper-slide')).addClass('active');
    })
}

$(function () {
    const sliderBrandsThumbs = $('.slider-brands-thumbs').attr('id');
    const sliderBrandsContent = $('.slider-brands-content').attr('id');

    initializeSliderBrands('#' + sliderBrandsThumbs, '#' + sliderBrandsContent);
});


